import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
const API = `${BACKEND_URL}/api`;

export const api = {
  stats: () => axios.get(`${API}/stats`).then((r) => r.data),
  facturas: (params) => axios.get(`${API}/facturas`, { params }).then((r) => r.data),
  incidencias: () => axios.get(`${API}/incidencias`).then((r) => r.data),
  proveedores: () => axios.get(`${API}/proveedores`).then((r) => r.data),
  updateProveedor: (cif, nombre) => axios.post(`${API}/proveedores/${cif}/normalize`, { nombre_normalizado: nombre }).then((r) => r.data),
  updateProveedorDetails: (cif, data) => axios.put(`${API}/proveedores/${cif}`, data).then((r) => r.data),
  factura: (id) => axios.get(`${API}/facturas/${id}`).then((r) => r.data),
  deleteFactura: (id) => axios.delete(`${API}/facturas/${id}`).then((r) => r.data),

  emails: () => axios.get(`${API}/emails`).then((r) => r.data),
  driveTree: () => axios.get(`${API}/drive/tree`).then((r) => r.data),
  config: () => axios.get(`${API}/config`).then((r) => r.data),
  run: () => axios.post(`${API}/pipeline/run`).then((r) => r.data),
  status: () => axios.get(`${API}/pipeline/status`).then((r) => r.data),
  reset: () => axios.post(`${API}/pipeline/reset`).then((r) => r.data),
  googleStatus: () => axios.get(`${API}/google/status`).then((r) => r.data),
  googleStart: () => axios.get(`${API}/google/oauth/start`).then((r) => r.data),
  googleDisconnect: () => axios.post(`${API}/google/disconnect`).then((r) => r.data),
  logs: (limit = 200) => axios.get(`${API}/logs`, { params: { limit } }).then((r) => r.data),
  clearLogs: () => axios.delete(`${API}/logs`).then((r) => r.data),
  uploadFactura: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/facturas/upload`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
};



export const API_BASE = API;
export const BACKEND = BACKEND_URL;

export const eur = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(n || 0);
